module.exports = __webpack_public_path__ + "media/images/brand-cap-40c011d00aa1dae189f9d73c97c97431.svg";